import React, {useEffect} from 'react';
import {Button, DialogActions, DialogContent, DialogTitle} from '@mui/material';
import {useDispatch, useSelector} from 'react-redux';
import {AppState} from '../../store';
import {AsyncTaskStatusType} from '../../shared/dtos';
import ErrorText from '../../components/ErrorText';
import CustomDialog from '../../components/CustomDialog';
import {removeFileFromLegalCaseAction} from "../../api/legalCase";
import {setRemoveFileFromLegalCaseTaskStatus} from "../../features/legal-case/legalCaseSlice";

interface DeleteLegalCaseFileDialogProps {
    handleClose: () => void;
    handleDelete: () => void;
    legalCaseId: number;
    fileId: number;
    fileName: string;
}

export const DeleteLegalCaseFileDialog: React.FC<DeleteLegalCaseFileDialogProps> = ({
                                                                                        handleClose,
                                                                                        handleDelete,
                                                                                        legalCaseId,
                                                                                        fileId,
                                                                                        fileName,
                                                                                    }) => {
    const removeFileFromLegalCaseTaskStatus = useSelector((state: AppState) => state.legalCase.removeFileFromLegalCaseTaskStatus);
    const dispatch: any = useDispatch();

    useEffect(() => {
        return () => {
            dispatch(setRemoveFileFromLegalCaseTaskStatus(null));
        };
    }, [dispatch]);

    const handleDeleteClick = async () => {
        try {
            const result = await dispatch(removeFileFromLegalCaseAction({legalCaseId: legalCaseId, fileId}));
            if (result.type === 'legalCase/removeFileFromLegalCase/fulfilled') {
                handleDelete();
                handleClose();
            }
        } catch (error) {
            console.error('Dosya silme işleminde bir hata oluştu:', error);
        }
    };

    return (
        <CustomDialog open={true} onClose={handleClose}>
            <DialogTitle>Dosyayı Sil ({fileName})</DialogTitle>
            <DialogContent>
                Bu dosyayı silmek istediğinizden emin misiniz?
                {removeFileFromLegalCaseTaskStatus?.type === AsyncTaskStatusType.Error &&
                    removeFileFromLegalCaseTaskStatus.errorMessage && (
                        <ErrorText type="form" message={removeFileFromLegalCaseTaskStatus.errorMessage}/>
                    )}
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose}>İptal</Button>
                <Button onClick={handleDeleteClick} color="error">
                    Sil
                </Button>
            </DialogActions>
        </CustomDialog>
    );
};
